function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling && summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

setInterval(() => {
  if (window.Klarna && window.Klarna.OnsiteMessaging) {
    let klarnaElements = document.querySelectorAll('klarna-placement');
    if (klarnaElements) {
      window.Klarna.OnsiteMessaging.refresh();
    }
  }
}, 700);

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        const headerMenu = document.querySelector('.header-menu');

        detailsElement.classList.add('menu-opening');
        headerMenu ? headerMenu.classList.remove('lock') : null;
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        if(summaryElement.closest('summary') && summaryElement.closest('summary').classList.contains('childlink-submenu')) {
          document.querySelector('.menu-drawer__navigation').style.overflowY = 'hidden';
        }
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;
    const headerMenu = document.querySelector('.header-menu');

    this.mainDetailsToggle.classList.remove('menu-opening');
    document.body.style.overflowY = 'auto';
    headerMenu ? headerMenu.classList.remove('lock') : null;
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
    document.querySelector('#accessease-icon').style.zIndex = '2147483645';
    document.querySelector('##hubspot-messages-iframe-container').style.zIndex = '2147483645';
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    const headerMenu = document.querySelector('.header-menu');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    if(detailsElement.classList.contains('childlink-submenu__details')) {
      document.querySelector('.menu-drawer__navigation').style.overflowY = 'auto';
    }
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
    headerMenu ? headerMenu.classList.remove('lock') : null;
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }

  connectedCallback() {
    const iconClose = document.querySelector('.mobile-facets__close');
    if (iconClose) {
      iconClose.addEventListener('click', function() {
        const facetsContainer = document.querySelector('.mobile-facets__disclosure');
        const bodyElement = document.querySelector('body');
        if (facetsContainer.hasAttribute('open')) {
          facetsContainer.classList.remove('menu-opening');
          bodyElement.classList.remove('overflow-hidden-mobile');
          setTimeout(() => {
            facetsContainer.removeAttribute('open');
          }, 400);
        }
      });
    }
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header') || document.getElementById('shopify-section-poloclub-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
      document.body.style.overflowY = 'hidden';
    });
    document.querySelector('#accessease-icon').style.zIndex = '3';
    document.querySelector('##hubspot-messages-iframe-container').style.zIndex = '3';
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    try {
      this.querySelector('[id^="ModalClose-"]').addEventListener(
        'click',
        this.hide.bind(this, false)
      );
      this.addEventListener('keyup', (event) => {
        if (event.code.toUpperCase() === 'ESCAPE') this.hide();
      });
      if (this.classList.contains('media-modal')) {
        this.addEventListener('pointerup', (event) => {
          if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
        });
      } else {
        this.addEventListener('click', (event) => {
          if (event.target === this) this.hide();
        });
      }
    } catch (error) {
      console.log(error);
    }
    
    this.colorModal = this.classList.contains('color-selector');
    this.bindedColorsScroll = false;
    if (this.colorModal) {
      this.contentImages = this.querySelector('.product-colors-content--images-wrapper');
      this.wrapperImages = this.querySelector('.product-colors-content--wrapper');
      this.scrollLeftPosition = 0;
      this.leftArrow = this.wrapperImages.querySelector('.arrow--left');
      this.rightArrow = this.wrapperImages.querySelector('.arrow--right');
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
    document.dispatchEvent(new CustomEvent('modalopen', { detail: { element: this }}));
    if (this.colorModal && !this.bindedColorsScroll) {
      console.log('show colors');
      this.bindedColorsScroll = true;
      this.bindScrollArrowsColors();
      this.bindMovementScrollArrows();
    }
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
    document.dispatchEvent(new CustomEvent('modalclose', { detail: { element: this }}));
  }

  moveLeft(distance = 350) {
    let finalPosition = this.scrollLeftPosition - distance;
    if (finalPosition < 0) {
      finalPosition = 0;
    }
    this.contentImages.scrollLeft = finalPosition;
  }

  moveRight(distance = 350) {
    this.contentImages.scrollLeft = this.scrollLeftPosition + distance;
  }

  changeVisibilityArrows(contentImages, contentScrollWidth) {
    let currentScroll = null;
    if (contentImages && contentScrollWidth) {
      currentScroll = contentImages.scrollLeft / contentScrollWidth;
    }
  
    if (currentScroll === null) {
      this.leftArrow.classList.remove('is--visible');
      this.rightArrow.classList.remove('is--visible');
      return;
    }
  
    if (currentScroll === 0) {
      this.leftArrow.classList.remove('is--visible');
      this.rightArrow.classList.add('is--visible');
    }
    if (currentScroll > 0 && currentScroll < 0.99) {
      this.leftArrow.classList.add('is--visible');
      this.rightArrow.classList.add('is--visible');
    }
    if (currentScroll >= 0.99) {
      this.leftArrow.classList.add('is--visible');
      this.rightArrow.classList.remove('is--visible');
    }
  }

  bindScrollArrowsColors() {
    let arrowsInterval = setInterval(() => {
      if (throttle) {
        clearInterval(arrowsInterval);
  
        let contentScrollWidth = this.contentImages.scrollWidth - this.wrapperImages.offsetWidth;
  
        if (contentScrollWidth > 40) {
          this.changeVisibilityArrows(this.contentImages, contentScrollWidth);
          let _this = this;
          this.contentImages.addEventListener('scroll', throttle(function() {
            _this.changeVisibilityArrows(_this.contentImages, contentScrollWidth);
            _this.scrollLeftPosition = _this.contentImages.scrollLeft;
          }, 350));
        }
      }
    }, 1000);
  }

  bindMovementScrollArrows() {
    let _this = this;
    this.leftArrow.addEventListener('click', function() {
      _this.moveLeft();
    });
    this.rightArrow.addEventListener('click', function() {
      _this.moveRight();
    });
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  openZoom(id) {
    document.querySelector('body').classList.add('no-overflow');
    this.zoomImagesWrapper.classList.add('active');
    let imageToZoom = this.querySelector(`#zoom-image-${id}`);
    
    if (imageToZoom) {
      imageToZoom.scrollIntoView(true);
    }
  }

  closeZoom() {
    document.querySelector('body').classList.remove('no-overflow');
    this.zoomImagesWrapper.classList.remove('active');
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      if (this.prevButton) {
        this.prevButton.setAttribute('disabled', 'disabled');
      }
    } else {
      if (this.prevButton) {
        this.prevButton.removeAttribute('disabled');
      }
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      if (this.nextButton) {
        this.nextButton.setAttribute('disabled', 'disabled');
      }
    } else {
      if (this.nextButton) {
        this.nextButton.removeAttribute('disabled');
      }
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector('a');
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute('tabindex');
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (button) button.setAttribute('tabindex', '-1');
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class DeliveryMessage extends HTMLElement {
  constructor() {
    super();
    this.daysAlert = this.querySelector('.product-delay__days');
    this.stock = null;
    this.metafields = null;
    this.currentVariant = null;
    const currentVariantInput = document.querySelector('product-form form input[name="id"]');
    var _this = this;
    if (currentVariantInput) {
      this.currentVariant = currentVariantInput.value;
      console.log('this.currentVariantInput', currentVariantInput);
      currentVariantInput.addEventListener('change', this.updateStock(_this));
    }
  }

  updateStock(_this) {
    console.log('updateStock');
    _this.getMetafields();
    if (_this.metafields) {
      console.log('this.metafields', this.metafields);
      _this.setStock(_this.metafields.variants, Number(_this.currentVariant));
    }
    _this.updateDelayDaysMsg();
  }

  async getMetafields(handle = null) {
    console.log('getMetafields');
    let productHandleSelector = this.querySelector('.product-delay__days');
    console.log('productHandleSelector', productHandleSelector);
    if (productHandleSelector) {
      let productHandle = handle ? handle : productHandleSelector.dataset.productHandle;
      console.log('productHandle', productHandle);
      if (productHandle) {
        let response = await fetch(`/products/${productHandle}?view=metafields`);
        if (response) {
          let metafields = await response.json();
          if (metafields) {
            this.metafields = metafields;
          }
        }
      }
    }
  }

  setStock(variants, currentVariant) {
    let variant = variants.find(variant => {
      return variant.id === currentVariant
    });

    if (variant) {
      this.stock = variant.stock;
      console.log('this.stock', this.stock);
    }
  }

  updateDelayDaysMsg() {
    if (!this.stock) return;
    if (this.stock.main === 0 && this.stock.reserve && this.stock.reserve > 0) {
      this.showDaysAlert();
    }
    else {
      this.hideDaysAlert();
    }
  }

  showDaysAlert() {
    if (this.daysAlert) {
      this.daysAlert.classList.add('active');
    }
  }

  hideDaysAlert() {
    if (this.daysAlert) {
      this.daysAlert.classList.remove('active');
    }
  }
}

customElements.define('delivery-message', DeliveryMessage);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantTitle();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    let variants = this.getVariantData();
    let optionSelected = this.options[0];

    this.currentVariant = variants.find((variant) => {
      return variant.title === optionSelected
    })
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
    mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  updateVariantTitle() {
    const targetBackInStockForm = document.querySelector('.target__backInStock-hubspot-form');
    if (targetBackInStockForm) {
      targetBackInStockForm.setAttribute('data-variant-title', `${this.currentVariant.title}`);
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(this.currentVariant.title, !this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(title, disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonStickBar = document.querySelector('.bt-stick-bar[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    const backInStockBtn = document.querySelector('.btn__back-in-stock');
    if (!addButton) return;

    if (disable && text) {
      addButton.setAttribute('disabled', 'disabled');
      addButtonText.textContent = text;
      if (addButtonStickBar) {
        addButtonStickBar.setAttribute('disabled', 'disabled');
        addButtonStickBar.textContent = text;
      }
      showNotifyBackInStock(backInStockBtn, productForm, this, title);
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
      if (addButtonStickBar) {
        addButtonStickBar.textContent = window.variantStrings.addToCart;
        addButtonStickBar.removeAttribute('disabled');
      }
      restoreFromBackInStock(backInStockBtn, backInStockBtn, addButton.parentElement);
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
    this.recommendedSize = null;
    this.selectVariant();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      let option = Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked ? radio.checked : null);
      if (option) {
        return option.value;
      }
    });
  }

  getSID(cookieName) {
    let cookie = {};
    document.cookie.split(';').forEach(function(el) {
      let [key,value] = el.split('=');
      cookie[key.trim()] = value;
    })
    return cookie[cookieName];
  }

  async getSBProductId(permalink, SID) {
    try {
      const response = await fetch(`https://vfr-v3-production.sizebay.technology/plugin/my-product-id?sid=${SID}&permalink=${permalink}`);
      const data = await response.json();
      const productSBId = data.id
      return productSBId;
    } catch (error) {}
  }

  async getSizeRecommended(productSBId, tenantId, SID) {
    try {
      const response = await fetch(`https://vfr-v3-production.sizebay.technology/api/me/analysis/${productSBId}?tenant=${tenantId}&sid=${SID}`);
      const data = await response.json();
      return data;
    } catch (error) {}
  }

  selectRecommendedVariant(sizeRecommended) {
    const arrLabels = Array.from(document.querySelectorAll('.label-product-size'));
    arrLabels.forEach(label => {
      const size = label.innerText.replace(/ /g, "");
      if (size === sizeRecommended) {
        label.click();
      }
    });
  }

  selectVariant() {
    const SID = this.getSID('SIZEBAY_SESSION_ID_V4');
    if (SID) {
      const productId = document.querySelector('fieldset[data-product-id]').getAttribute('data-product-id');
      const permalink = `https://www.poloclub.com/products/${productId}`;
      const tenantId = Shopify.shop_id;

      this.getSBProductId(permalink, SID).then(productSBId => {
        this.getSizeRecommended(productSBId, tenantId, SID).then(data => {
          data.recommendedSize ? this.recommendedSize = true : false;
          if (this.recommendedSize) {
            this.selectRecommendedVariant(data.recommendedSize);
          }
        })
      })
    }
  }
}

customElements.define('variant-radios', VariantRadios);

function displayQuickAddSizesSelector (productCardWrapper, showSizesButtons = true) {
  if (productCardWrapper) {
    const formsArray = Array.from(productCardWrapper.querySelectorAll('.collection__addproduct--form'));
    
    formsArray.forEach(element => {
      showSizesButtons ? element.classList.remove('hidden') : element.classList.add('hidden')
    });
  }
}

function resetToAddToCartButton (productCardWrapper) {
  if (productCardWrapper) {
    const quickAddToCartBtn = productCardWrapper.querySelector('.addToCartCollectionBtn');
    const addedToCartContent = productCardWrapper.querySelector('.collectionItemAddedContent');
    const hoverInterval = setInterval(() => {
      if (!productCardWrapper.classList.contains('keep-hover-effect') && quickAddToCartBtn && addedToCartContent) {
        clearInterval(hoverInterval);
        addedToCartContent.classList.add('hidden');
        displayQuickAddSizesSelector(productCardWrapper, false);
        quickAddToCartBtn.classList.remove('hidden');
      }
    }, 200);
  }
}

function displayQuickAddSuccessMessage (productCardWrapper) {
  const addedToCartContent = productCardWrapper.querySelector('.collectionItemAddedContent');
  
  displayQuickAddSizesSelector(productCardWrapper, false);
  productCardWrapper ? productCardWrapper.classList.add('keep-hover-effect') : null;
  addedToCartContent ? addedToCartContent.classList.remove('hidden') : null;
  
  const confirmationMessageInterval = setInterval(() => {
    clearInterval(confirmationMessageInterval);
    productCardWrapper ? productCardWrapper.classList.remove('keep-hover-effect') : null;
    const fadeOutEffectInterval = setInterval(() => {
      clearInterval(fadeOutEffectInterval);
      addedToCartContent ? addedToCartContent.classList.add('hidden') : null;
      resetToAddToCartButton(productCardWrapper);
    }, 200);
  }, 3000);
}

function addToCartIfOnlyVariant(productCardWrapper) {
  const formsArray = Array.from(productCardWrapper.querySelectorAll('.collection__addproduct--form'));

  if (formsArray && formsArray.length === 1) {
    let form = formsArray[0];
    if (form) {
      let buttonAddToCart = form.querySelector('.collection__addproduct');
      if (buttonAddToCart) {
        buttonAddToCart.click();
      }
    }
  }
}

function loadCollectionQuickAddClickListeners () {
  const quickAddToCartButton = Array.from(document.querySelectorAll('.addToCartCollectionBtn'));
  const quickAddProductGridWrapper = Array.from(document.querySelectorAll('.grid__item .card-wrapper'));

  quickAddToCartButton.forEach(element => {
    element.addEventListener('click', event => {
      const productGrid = event.target.closest('.grid__item .card-wrapper')
      event.target.classList.add('hidden');
      displayQuickAddSizesSelector(productGrid);
      addToCartIfOnlyVariant(productGrid);
    }, false)
  });

  quickAddProductGridWrapper.forEach(element => {
    element.addEventListener('mouseleave', debounce((event) => resetToAddToCartButton(event.target), 200))
  });
}

loadCollectionQuickAddClickListeners();
if (document.body.classList.contains("page-search")) {
  document.addEventListener('DOMContentLoaded', function() {
    setTimeout(() => {
      loadCollectionQuickAddClickListeners();
    }, 1000);
  }, false);
}

async function getCheckoutPrices() {
  try {
    let response = await fetch(`${routes.base_url}/checkout`);
    if (response.ok) {
      let html = await response.text();

      if (html) {
        let parser = new DOMParser();
        let doc = parser.parseFromString(html, 'text/html');
  
        if (doc) {
          let discountApplied = false;
          let totalDiscountedPrice = null;
          
          let totalPriceSpan = doc.querySelector('.total-line--subtotal .total-line__price span[data-checkout-subtotal-price-target]');
          let totalPrice = totalPriceSpan && totalPriceSpan.dataset ? totalPriceSpan.dataset.checkoutSubtotalPriceTarget : null;
          
          let discountSpan = doc.querySelector('.total-line--reduction .total-line__price span[data-checkout-discount-amount-target]');
          let discountPrice = discountSpan && discountSpan.dataset ? discountSpan.dataset.checkoutDiscountAmountTarget : null;
          
          if (discountPrice) {
            discountApplied = true;
          }
  
          if (discountApplied) {
            let totalWithDiscountAppliedSpan = doc.querySelector('.total-line .total-line__price.payment-due span[data-checkout-payment-due-target]');
            totalDiscountedPrice = totalWithDiscountAppliedSpan.dataset ? totalWithDiscountAppliedSpan.dataset.checkoutPaymentDueTarget : null;
          }
  
          return {
            totalPrice: totalPrice,
            discountPrice: discountPrice,
            totalDiscountedPrice: totalDiscountedPrice
          };
        }
      }
    }
    else {
      return response;
    }
  }
  catch (err) {
    // There was an error
    console.warn('GET Checkout error', err);
    return null;
  }
}

function throttle(func, limit) {
  let lastFunc;
  let lastRan;
  return function() {
    const context = this;
    const args = arguments;
    if (!lastRan) {
      func.apply(context, args);
      lastRan = Date.now();
    } else {
      clearTimeout(lastFunc);
      lastFunc = setTimeout(function() {
        if (Date.now() - lastRan >= limit) {
          func.apply(context, args);
          lastRan = Date.now();
        }
      }, limit - (Date.now() - lastRan));
    }
  };
}

function calcCartItemsHeight() {
  let minimalAdjustment = 10;
  let cartDrawerWrapperHeight = 0;
  let cartDrawerWrapperVerticalPaddings = 0;
    let cartDrawerWrapperPaddingTop = 0;
    let cartDrawerWrapperPaddingBottom = 0;
  let cartDrawerWrapperHeaderHeight = 0;
    let cartDrawerWrapperHeaderMarginBottom = 0;
  let cartDrawerWrapperFooterHeight = 0;

  let cartItemsCalculatedHeight = 0;

  let cartDrawerWrapper = document.querySelector('#drawer-cart .drawer-cart__wrapper');
  if (cartDrawerWrapper) {
    //Height container calc
    cartDrawerWrapperHeight = cartDrawerWrapper.offsetHeight;
    let cartDrawerWrapperStyles = window.getComputedStyle(cartDrawerWrapper);
    if (cartDrawerWrapperStyles.paddingTop.length) {
      cartDrawerWrapperPaddingTop = parseInt(cartDrawerWrapperStyles.paddingTop);
    }
    if (cartDrawerWrapperStyles.paddingBottom.length) {
      cartDrawerWrapperPaddingBottom = parseInt(cartDrawerWrapperStyles.paddingBottom);
    }
    cartDrawerWrapperVerticalPaddings = cartDrawerWrapperPaddingTop + cartDrawerWrapperPaddingBottom;

    // Header container calc
    let cartDrawerWrapperHeader = cartDrawerWrapper.querySelector('.drawer-cart__header');
    if (cartDrawerWrapperHeader) {
      cartDrawerWrapperHeaderHeight = cartDrawerWrapperHeader.offsetHeight;
      let cartDrawerWrapperHeaderStyle = window.getComputedStyle(cartDrawerWrapperHeader);
      if (cartDrawerWrapperHeaderStyle.marginBottom.length) {
        cartDrawerWrapperHeaderMarginBottom = parseInt(cartDrawerWrapperHeaderStyle.marginBottom);
        cartDrawerWrapperHeaderHeight = cartDrawerWrapperHeaderHeight + cartDrawerWrapperHeaderMarginBottom;
      }
    }

    // Footer container calc
    let cartDrawerFooter = cartDrawerWrapper.querySelector('#main-cart-footer');
    if (cartDrawerFooter) {
      cartDrawerWrapperFooterHeight = cartDrawerFooter.offsetHeight;
    }

    // Total calc
    cartItemsCalculatedHeight = cartDrawerWrapperHeight
      - cartDrawerWrapperVerticalPaddings
      - cartDrawerWrapperHeaderHeight
      - cartDrawerWrapperFooterHeight;
  }
}

function getCartData() {
  let cartData = document.querySelector('.cart-data');
  let cartItemsData = cartData.querySelectorAll('li.cart-item');
  let cart = {
    currency: cartData.dataset.cartCurrency,
    value: parseFloat(cartData.dataset.cartTotal),
    items: []
  };
  if(cartItemsData) {
    for(i = 0;i < cartItemsData.length;i++) {
      let item = cartItemsData[i];
      cart.items.push({
        item_id: item.dataset.productId,
        item_product_id: item.dataset.productId,
        item_name: item.dataset.productTitle,
        affiliation: cartData.dataset.shop,
        item_brand: item.dataset.productVendor,
        item_category: item.dataset.productCategory,
        item_variant: item.dataset.productVariant,
        item_variant_id: item.dataset.id,
        compare: parseFloat(item.dataset.productCompare),
        price: parseFloat(item.dataset.productPrice),
        currency: item.dataset.productCurrency,
        quantity: parseInt(item.dataset.productQuantity)
      });
    }
  }

  return cart;
}

function getCartDataPH() {
  let cartData = document.querySelector('.cart-data');
  let cartItemsData = cartData.querySelectorAll('li.cart-item');
  let cart = {
    currency: cartData.dataset.cartCurrency,
    value: parseFloat(cartData.dataset.cartTotal),
    items: []
  };
  if(cartItemsData) {
    for(i = 0;i < cartItemsData.length;i++) {
      let item = cartItemsData[i];
      cart.items.push({
        item_id: item.dataset.productSku,
        item_product_id: item.dataset.productId,
        item_name: item.dataset.productTitle,
        affiliation: cartData.dataset.shop,
        item_brand: item.dataset.productVendor,
        item_category: item.dataset.productCategory,
        item_variant: item.dataset.productVariant,
        item_variant_id: item.dataset.id,
        compare: parseFloat(item.dataset.productCompare),
        price: parseFloat(item.dataset.productPrice),
        currency: item.dataset.productCurrency,
        quantity: parseInt(item.dataset.productQuantity)
      });
    }
  }

  return cart;
}

function recalcVh() {
  // We execute the same script as before
  let vh = window.innerHeight;
  document.documentElement.style.setProperty('--viewport-height', `${vh}px`);
}

function bindCookieLink() {
  let cookieLink = document.querySelector('.didomi__link');
  if (cookieLink) {
    cookieLink.addEventListener('click', function() {
      privacyBanner?.showPreferences();
    });
  }
}

function showBackInStock(event) {
  event.preventDefault();

  const targetBackInStockForm = document.querySelector('.target__backInStock-hubspot-form');
  
  if (targetBackInStockForm) {
    event.target.style.display = 'none';
    targetBackInStockForm.style.display = 'block';
    handleRestOfForm(targetBackInStockForm, 'none');
  }
}

function showNotifyBackInStock(backInStockBtn, productForm, variantRadios, variantTitle) {
  if (variantRadios && variantTitle) {
    variantRadios.querySelectorAll('input').forEach(input => {
      if (input.value === variantTitle && input.hasAttribute('not-available')) {
        const addToCartBtn = productForm.querySelector('button[name="add"]');
        if (backInStockBtn && productForm && addToCartBtn && productContainer) {
          backInStockBtn.style.display = 'flex';
          addToCartBtn.style.display = 'none';
        } else {
          const successMessage = document.querySelector('.back-in-stock-success');
          successMessage ? successMessage.style.display = 'flex' : null;
          
          const addButton = document.querySelector('.product-view__submit-button');
          if (addButton) {
            addButton.style.display = 'flex';
            addButton.insertAdjacentElement('beforebegin', successMessage);
            handleRestOfForm(addButton, 'block');
          }
        }
      }
    })
  }
}

function restoreFromBackInStock(backInStockBtn, productForm, productForm) {
  const addButton = document.querySelector('.product-view__submit-button');
  const successMessage = document.querySelector('.back-in-stock-success');
  const targetBackInStock = document.querySelector('.target__backInStock-hubspot-form');
  
  successMessage ? successMessage.style.display = "none" : null;
  backInStockBtn ? backInStockBtn.style.display = "none" : null;
  targetBackInStock ? targetBackInStock.style.display = 'none' : null;
  productForm ? productForm.parentElement.style.marginTop = '2.4rem' : null;
  addButton ? addButton.style.display = 'flex' : null;
  handleRestOfForm(addButton, 'block');
}

function handleRestOfForm(target, displayOrder) {
  if (target) {
    let nextSiblingTarget = target.parentElement.nextElementSibling;
  
    const nextSiblings = [];
    while (nextSiblingTarget) {
      nextSiblings.push(nextSiblingTarget);
      nextSiblingTarget = nextSiblingTarget.nextElementSibling;
    }
    if (nextSiblings.length > 0) {
      nextSiblings.forEach(element => {
        element.style.display = displayOrder;
      });
    }
  }
}

async function setCartAttributes(attributes = {}) {
  const result = await fetch("/cart/update.json", {
      method: "POST",
      headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
      },
      body: JSON.stringify({
          attributes: attributes 
      })
  });

  return result.json();
}

document.addEventListener('DOMContentLoaded', function() {
  recalcVh();
  calcCartItemsHeight();
  bindCookieLink();
  window.addEventListener('resize', throttle(recalcVh, 600));
  window.addEventListener('resize', throttle(calcCartItemsHeight, 600));

  setInterval(function() {
    calcCartItemsHeight();
  }, 3000)
});